export type BankValidationDetail = {
  errors?: {
    __all__?: string[];
    [field: string]: string[] | undefined;
  };
  customers?: Array<{
    id: string;
    errors?: Record<string, string[]>;
  }>;
  id?: number;
  bank?: string;
};

export function getBankDocumentErrorMessage(res: { _message?: string; _detail?: unknown } | null) {
  const detail = res?._detail as BankValidationDetail | undefined;
  const allErrors = detail?.errors?.__all__;

  if (Array.isArray(allErrors) && allErrors.length) {
    return [res?._message, ...allErrors].filter(Boolean).join('\n');
  }

  return res?._message;
}
